import styled, { css } from 'styled-components';

export const Container = styled.div`
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    background-color: rgba(0,0,0,.45);
    animation: Show .1s ease-out;    
    @keyframes Show{
        0% {
            opacity: 0;
            transform: scale(1.2);
        }
        100% {
            opacity: 0;
            transform: scale(1);
        }
    };
    ${({ isLoading }) =>
        isLoading &&
        css`
            pointer-events: none;
        `
    };
`;
export const Content = styled.div`
    width: 25rem;
    padding: 0.75rem;
    background: #f6f6f6;
    border-radius: 10px;
    .xtR{
        background-color: #ffffff;
        border-radius: 10px 10px 0px 0px;
    }
`;
export const AvatarWrapper = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 15rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: transparent linear-gradient(325deg, #1D86FF 0%, #7EF6B7 100%) 0% 0% no-repeat padding-box;
    background-size: 100% 50%;
    border-radius: 10px 10px 0px 0px;
    > div:nth-child(1){
        display: flex;
        width: 10rem;
        height: 10rem;
        padding: 0.2rem;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
    }
    > span{
        margin-top: 0.75rem;
        font-size: 1.2rem;
        font-weight: 500;
    }
    > span:nth-child(2){
        position: absolute;
        display: flex;
        top: -5px;
        right: 5px;
        padding: 0.2rem;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #ffffff;
        border-radius: 50%;
        transition: background-color 300ms;

        &:hover{
            background-color: rgba(0,0,0,.1);
        }
    }
`;
export const Body = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 2rem;
    padding: 0 1rem 1rem 1rem;
    border-radius: 0 0 10px 10px;
    background-color: #ffffff;
    > div {
        display: flex;
        width: 100%;
        flex-direction: column;
        gap: 0.75rem;
        > label{
            font-size: 1.1rem;
            font-weight:bold;
        }
    }
`;
export const Input = styled.input`
    outline: none;
    border: none;
    width: 100%;
    height: 3rem;
    padding: 5px 12px;
    font-size: 14px;
    line-height: 20px;
    border-radius: 6px;
    background-color:${({ theme }) => theme.colors.__white};
    border: solid 1px #ececec; 
    pointer-events: ${({ loading }) => loading ? 'none' : 'auto'};
    color:${({ theme }) => theme.colors.__gray[750]};
`;
export const Actions = styled.div`
    display: flex;
    width: 100%;
    gap: 1rem;
    margin-top: 1rem;
    justify-content: center;
    align-items: center;
    > button {
        outline: none;
        border:none;
        position: relative;
        display: flex;
        width: 100%;
        height: 3rem;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        font-weight: bolder;
        cursor: pointer;
        background-color: #ffffff;
        /* box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1); */
        span{
            position: absolute;
            left: 20px;
        }
    }
    .btn--edit{
        color: #dede28;
        border:solid 1px #ffffff;
        &:hover{
            border:solid 1px #dede28;
        }
    }
    .btn--delete-cancel{
        color:#ce3747;
        border:solid 1px #ffffff;
        &:hover{
            border: solid 1px #ce3747;
        }
    }
    .btn--edit{
        color: #dede28;
        border:solid 1px #ffffff;
        &:hover{
            border:solid 1px #dede28;
        }
    }
    .btn--save{
        color:#1D86FF;
        border:solid 1px #ffffff;
        &:hover{
            border: solid 1px #1D86FF;
        }
    }
`;
export const LoadingProgress = styled.div`
 position: fixed;
  display: ${({ isOpen }) => isOpen ? 'flex' : 'none'};
  top:0px;
  left: 0px;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  cursor: default;
  animation: ModalShow .1s ease-out;
  user-select: none;
  @keyframes ModalShow{
    0% {
      opacity: 0;
      transform: scale(1.2);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }
  > div {
    display: flex;
    width:400px;
    height: 500px;
    border-radius: 6px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    gap: 0.5rem;
  }
`;